// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3hGes","Logo":"Toolbar_Logo__3UAmW","desktopOnly":"Toolbar_desktopOnly__1_gJ5","mobileOnly":"Toolbar_mobileOnly__3o893"};